(() => {
  // These owners cover header/drawer actions, the modal, and the search-page form.
  const selector = '.search-action, #search-modal, .search-page-input__parent';
  const previousAttributes = new WeakMap();
  const closingDialogs = new WeakSet();
  let lastCookie;
  let allowed = false;

  function readCookie() {
    const prefix = 'avada_cookie_consent=';
    for (const part of document.cookie.split(';')) {
      const cookie = part.trim();
      if (cookie.startsWith(prefix)) return cookie.slice(prefix.length);
    }
    return '';
  }

  function hasConsent(raw) {
    try {
      const consent = JSON.parse(decodeURIComponent(raw));
      return consent?.analytics === true && consent?.preferences === true;
    } catch {
      return false;
    }
  }

  async function closeSearchDialog() {
    const modal = document.getElementById('search-modal');
    const dialog = modal?.querySelector('dialog');
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open || closingDialogs.has(modal)) return;

    closingDialogs.add(modal);
    try {
      // Use the component API so its scroll lock and event listeners are released.
      if (typeof modal.closeDialog === 'function') await modal.closeDialog();
      else dialog.close();
    } finally {
      closingDialogs.delete(modal);
    }
  }

  function updateContainers() {
    for (const container of document.querySelectorAll(selector)) {
      if (!allowed) {
        if (!previousAttributes.has(container)) {
          previousAttributes.set(container, {
            inert: container.getAttribute('inert'),
            'aria-hidden': container.getAttribute('aria-hidden'),
          });
        }
        container.setAttribute('inert', '');
        container.setAttribute('aria-hidden', 'true');
      } else if (previousAttributes.has(container)) {
        for (const [name, value] of Object.entries(previousAttributes.get(container))) {
          if (value === null) container.removeAttribute(name);
          else container.setAttribute(name, value);
        }
        previousAttributes.delete(container);
      }
    }
    if (!allowed) void closeSearchDialog();
  }

  function refresh(force = false) {
    const raw = readCookie();
    if (!force && raw === lastCookie) return;
    lastCookie = raw;
    allowed = hasConsent(raw);
    document.documentElement.classList.toggle('search-consent-granted', allowed);
    updateContainers();
  }

  function guardInteraction(event) {
    const searchShortcut = event.type === 'keydown' && event.metaKey && event.key === 'k';
    const insideSearch = event.target instanceof Element && event.target.closest(selector);
    if (!searchShortcut && !insideSearch) return;

    // A choice may have changed since the last poll or before Avada emits an event.
    refresh(true);
    if (!allowed) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  for (const type of ['click', 'submit', 'input', 'keydown']) {
    document.addEventListener(type, guardInteraction, true);
  }
  // Handles section replacements; attributes are excluded to avoid observing our writes.
  new MutationObserver(() => refresh(true)).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  // Also handles a dialog opening in an already queued animation frame after rejection.
  document.addEventListener('dialog:open', (event) => {
    if (event.target instanceof Element && event.target.id === 'search-modal') refresh(true);
  }, true);
  document.addEventListener('visitorConsentUpdated', () => refresh(true));
  document.addEventListener('visibilitychange', () => refresh(true));
  window.addEventListener('pageshow', () => refresh(true));
  // Cookie writes alone are not observable through DOM mutation events.
  window.setInterval(() => refresh(), 250);
  refresh(true);
})();
